import { useTwilioRoom } from './useTwilioRoom';
import { useMediaControls } from './useMediaControls';
import { useAudioDevices } from './useAudioDevices';
import { useSpeakerDevices } from './useSpeakerDevices';
import { useCameraDevices } from './useCameraDevices';

interface UseVideoCallRoomOptions {
  twilioToken?: string;
  videoCallId?: string;
  isConfirmed: boolean;
}

export const useVideoCallRoom = ({
  twilioToken,
  videoCallId,
  isConfirmed,
}: UseVideoCallRoomOptions) => {
  const {
    room,
    localParticipant,
    remoteParticipants,
    isConnecting,
    connectionError,
    retry,
    disconnect,
  } = useTwilioRoom({
    token: isConfirmed ? twilioToken : undefined,
    roomName: isConfirmed ? videoCallId : undefined,
  });

  const { mediaState, toggleVideo, toggleAudio, toggleSpeaker, toggleScreenShare } =
    useMediaControls({ room });

  const { microphones, activeMicId, switchMicrophone } = useAudioDevices(room);
  const { speakers, activeSpeakerId, switchSpeaker } = useSpeakerDevices();
  const { cameras, activeCameraId, switchCamera } = useCameraDevices(room);

  return {
    room: {
      isConnecting,
      connectionError,
      retry,
      localParticipant,
      remoteParticipants,
      disconnect,
    },
    media: {
      state: mediaState,
      toggleVideo,
      toggleAudio,
      toggleSpeaker,
      toggleScreenShare,
    },
    devices: {
      microphones,
      activeMicId,
      switchMicrophone,
      speakers,
      activeSpeakerId,
      switchSpeaker,
      cameras,
      activeCameraId,
      switchCamera,
    },
  };
};
